import { Button } from '../../../components/ui';
import { Alert } from '../../../models/view';
import { generateShortUUID, openUrl } from '../../../utils';

export const makeProgramSurveyAlert = (programSurveyUrl: string): Alert => ({
  id: generateShortUUID(),
  type: 'success',
  title: 'Take the Program Survey',
  message: () => <Button text="Open" color="secondary" onPress={() => openUrl(programSurveyUrl)} />,
  canClose: false,
});
